import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;

  ${media.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 20px;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${({ theme }) => theme.colors['neutral-100']};
  margin: 0;

  ${media.mobile} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  ${media.mobile} {
    width: 100%;
    flex-wrap: wrap;
  }
`;
